import React from 'react';
import { Box, Typography } from '@mui/material';

import { v2Colors } from '../../design/theme';

const DISPLAY_FONT = '"Foregen", "Roboto Slab", Georgia, serif';

const FEATURES = [
  { emoji: '💉', label: 'No antibiotics' },
  { emoji: '🌾', label: 'Free range' },
  { emoji: '🐔', label: 'No force feed' },
];

function StoryFeature({ emoji, label }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 1,
        flex: 1,
        minWidth: 0,
      }}
    >
      <Box
        sx={{
          width: { xs: 52, md: 56 },
          height: { xs: 52, md: 56 },
          borderRadius: '50%',
          border: '1.5px solid',
          borderColor: 'rgba(248, 232, 204, 0.85)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        aria-hidden
      >
        <Typography component="span" sx={{ fontSize: { xs: 22, md: 24 }, lineHeight: 1 }}>
          {emoji}
        </Typography>
      </Box>
      <Typography
        component="span"
        sx={{
          fontFamily: DISPLAY_FONT,
          fontWeight: 700,
          fontSize: { xs: '0.72rem', md: '0.8rem' },
          lineHeight: 1.25,
          color: v2Colors.canvas,
          letterSpacing: '0.02em',
          textAlign: 'center',
        }}
      >
        {label}
      </Typography>
    </Box>
  );
}

export default function HowWeRaiseSection() {
  return (
    <Box
      component="section"
      aria-labelledby="how-we-raise-heading"
      sx={{ mb: { xs: 3, md: 4 } }}
    >
      <Box
        sx={{
          position: 'relative',
          overflow: 'hidden',
          textAlign: 'center',
          bgcolor: v2Colors.primary,
          color: v2Colors.canvas,
          borderRadius: { xs: 3, md: 3.5 },
          px: { xs: 2.5, md: 3 },
          py: { xs: 2.75, md: 3.25 },
          '&::before': {
            content: '""',
            position: 'absolute',
            inset: 0,
            background:
              'radial-gradient(circle at 30% 18%, rgba(212, 160, 23, 0.14) 0%, transparent 42%)',
            pointerEvents: 'none',
          },
        }}
      >
        <Typography
          component="p"
          sx={{
            position: 'relative',
            fontFamily: DISPLAY_FONT,
            fontStyle: 'italic',
            fontSize: { xs: '0.95rem', md: '1.05rem' },
            color: v2Colors.canvas,
            opacity: 0.92,
            mb: 0.75,
            letterSpacing: '0.03em',
          }}
        >
          — how we raise them
        </Typography>
        <Typography
          id="how-we-raise-heading"
          component="h2"
          sx={{
            position: 'relative',
            fontFamily: DISPLAY_FONT,
            fontWeight: 700,
            fontSize: { xs: '1.35rem', md: '1.55rem' },
            lineHeight: 1.15,
            letterSpacing: '-0.01em',
            mb: { xs: 2.25, md: 2.5 },
            color: v2Colors.canvas,
          }}
        >
          Raised by nature,
          <br />
          not needles
        </Typography>
        <Box
          sx={{
            position: 'relative',
            display: 'flex',
            justifyContent: 'space-between',
            gap: { xs: 1, md: 1.5 },
            px: { xs: 0.5, md: 1 },
          }}
        >
          {FEATURES.map(({ emoji, label }) => (
            <StoryFeature key={label} emoji={emoji} label={label} />
          ))}
        </Box>
      </Box>
    </Box>
  );
}
